import React, { Component } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import _ from 'lodash';
import SummaryRow from './SummaryRow'
import CasoSummary from '../../casos/CasoSummary'
import moment from 'moment'


class CasoFormStep5 extends Component{
    render(){
        return(
            <form onSubmit={this.props.handleSubmit.bind(this)}>
                <div className="row summary">
                    <div className="col-md-12">
                        <h2>Resumen del Caso</h2>
                    </div>
                    <SummaryRow col="12" key="paciente" label="Paciente" value={this.props.summary.nombre + " " + this.props.summary.apellidos}   />
                    <div className="col-md-12">
                        <CasoSummary summary={this.props.summary} addresses={this.props.addresses} />
                    </div>
                </div>
                <div className="form-actions">
                    <button type="submit" onClick={this.props.previousPage} className="btn btn-secondary next">
                        <i className="fa fa-chevron-left"></i>
                        &nbsp; Anterior
                    </button>
                    <button type="submit" className="btn btn-primary next float-right">
                        Enviar &nbsp;
                        <i className="fa fa-check-circle-o"></i>
                    </button>
                </div>

            </form>
        )
    }
}
export default reduxForm({
    form: 'wizard', //                 <------ same form name
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    // validate,
})(CasoFormStep5);


// WEBPACK FOOTER //
// ./resources/assets/js/components/forms/newcaso/CasoFormStep5.jsx